import Carousel from "react-multi-carousel";
import styles from "../Jobseeker.module.css";
import CategoryCard from "./CategoryCard";
import { images } from "../../../assets/images";

const CategoryCarousel = () => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 3, // optional, default to 1.
    },
  };

  return (
    <Carousel
      swipeable={true}
      draggable={true}
      showDots={true}
      responsive={responsive}
      ssr={true} // means to render carousel on server-side.
      infinite={true}
      autoPlay={true}
      autoPlaySpeed={5000}
      keyBoardControl={true}
      customTransition="all .5"
      transitionDuration={500}
      removeArrowOnDeviceType={["tablet", "mobile"]}
      containerClass="container-with-dots"
      itemClass="image-item"
      dotListClass="container_dot_list"
      renderDotsOutside={true}
    >
      <div className={styles.itemCenter}>
        <CategoryCard
          icon={images.tech}
          title="Technology"
        />
      </div>
      <div className={styles.itemCenter}>
        <CategoryCard
          icon={images.engg}
          title="Engineering"
        />
      </div>
      <div className={styles.itemCenter}>
        <CategoryCard
          icon={images.biz}
          title="Business"
        />
      </div>
      <div className={styles.itemCenter}>
        <CategoryCard
          icon={images.hr}
          title="Human Resource"
        />
      </div>
      <div className={styles.itemCenter}>
        <CategoryCard
          icon={images.finance}
          title="Finance"
        />
      </div>
      <div className={styles.itemCenter}>
        <CategoryCard
          icon={images.marketing}
          title="Marketing"
        />
      </div>
      <div className={styles.itemCenter}>
        <CategoryCard
          icon={images.design}
          title="Design"
        />
      </div>
      <div className={styles.itemCenter}>
        <CategoryCard
          icon={images.sales}
          title="Sales"
        />
      </div>
    </Carousel>
  );
};

export default CategoryCarousel;
